import React, { Component } from 'react';

import DEFINE, { DETAIL_ACTIONS } from '../../../../../../../constants/Define';

import {
    FormWrapperInputComponent,
} from "../../../../../common/component/Index";
import Wrapper from '../../../../../common/component/Wrapper';
import UploadImage from '../../../../../common/component/UploadImage';


import './Images.less';
import Input from '../../../../../common/component/Input';
import { checkUndefine, formatImageUrlSlug, formatUrlSlug } from '../../../../../../../helpers/functions';
import { cloneDeep, isEmpty } from 'lodash';
import Media from './Media';

export default class Images extends Component {
    constructor(props) {
        super(props);
        const { tour } = this.props;
        this.state = {
            imageUrlSlug: tour.imageUrlSlug || ''
        };
    }

    onChangeUrlSlug = e => {
        const value = e.target.value || '';
        this.props.onChange('imageUrlSlug', formatImageUrlSlug(value));
        this.setState({
            imageUrlSlug: formatImageUrlSlug(value)
        });
        return;
    }

    render() {
        const { t, tour, validation, uploadingField, action } = this.props;
        const { imageUrlSlug } = this.state;
        const checkDefaultTranlations = action === 'UPDATE' && tour && (tour.translations).find(el => tour.languageCode === el.languageCode);
        const isDefaultLanguage = (!isEmpty(checkDefaultTranlations) && checkDefaultTranlations.isDefault) || false;
        return (
            <Wrapper className="tour-detail-images row">
                <Wrapper className='col-md-12'>
                    <FormWrapperInputComponent
                        typeInput={true}
                        isRequired={'right'}
                        isValidation={true}
                        labelTitle={t(`item.tour.imageSlug`)}
                        classLabel="col-md-2"
                        >
                        <Input placeholder="" type={`text`}
                            readOnly={action !== 'CREATE' && !isDefaultLanguage}
                            className={`form-control`}
                            classInputForm="col-md-10"
                            name={'imageUrlSlug'}
                            onChange={this.onChangeUrlSlug}
                            value={checkUndefine(tour.imageUrlSlug)} />
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        isRequired={'right'}
                        isValidation={true}
                        dataValidation={tour.thumbImage}
                        validation={validation.thumbImage}
                        messageBelowInput={true}
                        classLabel="col-md-4"
                        classInputForm="col-md-8"
                        labelTitle={t(`item.tour.thumbImage`)}
                        className="mb-0"
                    >
                        <UploadImage
                            multiple={false}
                            isPreview3x3={true}
                            loading={uploadingField === 'thumbImage'}
                            thumbnailSize={'100%'}
                            buttonSize={180}
                            thumbnailStyle={{ maxHeight: 180 }}
                            uploadText={t('item.tour.uploadFile')}
                            loadingText={t('item.tour.uploading')}
                            onChange={files => this.props.onUploadImage(files, 'thumbImage', imageUrlSlug)}
                            onRemoveThumbnail={(url) => this.props.onRemoveImage(url, 'thumbImage')}
                            thumbnails={this.getThumbSources([tour.thumbImage])} />

                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <FormWrapperInputComponent
                        typeInput={true}
                        classLabel="col-md-4"
                        classInputForm="col-md-8"
                        labelTitle={t(`item.tour.specialImage`)}
                        className="mb-0"
                    >
                        <UploadImage
                            multiple={false}
                            isPreview3x3={true}
                            loading={uploadingField === 'specialImage'}
                            thumbnailSize={'100%'}
                            buttonSize={180}
                            thumbnailStyle={{ maxHeight: 180 }}
                            uploadText={t('item.tour.uploadFile')}
                            loadingText={t('item.tour.uploading')}
                            onChange={files => this.props.onUploadImage(files, 'specialImage', imageUrlSlug)}
                            onRemoveThumbnail={(url) => this.props.onRemoveImage(url, 'specialImage')}
                            thumbnails={this.getThumbSources([tour.specialImage])} />
                    </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-12">
                    <Media
                        tour={tour}
                        validation={validation}
                        uploadingField={uploadingField}
                        onUploadImage={this.props.onUploadImage}
                        onRemoveImage={this.props.onRemoveImage}
                        getThumbSources={this.getThumbSources}
                        onChangeOrderSlide={this.props.onChangeOrderSlide}
                        imageUrlSlug={imageUrlSlug}
                        t={t}
                    />
                    {/* <FormWrapperInputComponent
                        typeInput={true}
                        isRequired={'right'}
                        isValidation={true}
                        dataValidation={tour.slideShowImages}
                        validation={validation.slideShowImages}
                        messageBelowInput={true}
                        classLabel="col-md-2"
                        classInputForm="col-md-10"
                        labelTitle={t(`item.tour.slideShowImages`)}
                        className="mb-0"
                    >
                        <UploadImage
                            multiple={true}
                            isPreview3x3={true}
                            loading={uploadingField === 'slideShowImages'}
                            thumbnailSize={120}
                            buttonSize={120}
                            uploadText={t('item.tour.uploadFile')}
                            loadingText={t('item.tour.uploading')}
                            allowChangeOrder={true}
                            onChange={files => this.props.onUploadImage(files, 'slideShowImages', imageUrlSlug)}
                            // onChangeOrder={this.onChangeImagesOrder}
                            onRemoveThumbnail={(url) => this.props.onRemoveImage(url, 'slideShowImages')}
                            thumbnails={this.getThumbSources(tour.slideShowImages)}/>
                    </FormWrapperInputComponent> */}
                </Wrapper>
            </Wrapper>
        )
    }

    onChangeImagesOrder = (e) => {
        const slideImgs = cloneDeep(this.props.tour.slideShowImages || []);
        const newSlideImgs = slideImgs.map(x=>{
            return {
                ...x,
                order: e.findIndex(y=>y.endsWith(x.url))
            };
        }).sort((a, b) => a.order - b.order);
        this.props.onChangeOrderSlide({name: 'slideShowImages', value: newSlideImgs});
    }

    getThumbSources(thumbs) {
        return thumbs.filter(t => t && Object.keys(t).length > 0).map(t => `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t.url}`)
    }

}

Images.defaultProps = {
    onChange: (fieldName, value) => { },
    uploadingField: undefined,
}

